export const setPayableOrders = {
  SET_PAYABLE_ORDERS(state, payload) {
    state.payableOrders = payload;
  }
};
